module.exports = __webpack_public_path__ + "img/reference-gourmetundpapeterie.53a71879.webp";